import { Directive } from '@angular/core';

@Directive({
  selector: '[app-error]',
  host: { class: 'absolute bottom-0 px-2 text-sm font-medium text-red-500' },
})
export class ErrorDirective {}
